import * as yup from "yup";
import {oneOfNumberValidator, requiredMessage, stringValidator} from "@/utils/yupValidators";
import {UnitType, YesNo} from "@/choices";
import {HospitalType, Priority} from "../choices";
import {triageTransportBaseSchema} from "../triage/schema";

yup.addMethod(yup.string, 'containsDigit', function containsDigit(value) {
    return this.test(`test-contains-digit`, gettext('Must contain letters and digits'), function (value) {
        return /\d/.test(value) && /[A-Za-z]/.test(value)
    });
});

export const transportSchema = {
    ...triageTransportBaseSchema,
    diagnose: stringValidator.required(requiredMessage),
    ventilated: oneOfNumberValidator(YesNo),
    unitType: oneOfNumberValidator(UnitType),
    unitTypeSpec: yup.string().nullable().when('unitType', {
        is: (val) => val === UnitType.OTHER,
        then: () => {
            return stringValidator.required(requiredMessage)
        }
    }),
    callSign: stringValidator.required(requiredMessage).uppercase().when('unitType', {
        is: (val) => [UnitType.RV, UnitType.RZP, UnitType.RLP].includes(val),
        then: () => {
            return yup.string().containsDigit()
        }
    }),
    transportPriority: stringValidator.oneOf(Object.values(Priority)).required(requiredMessage),
    hospitalType: stringValidator.oneOf(Object.values(HospitalType)).required(requiredMessage),
};

export function pickTransportValues(patientData) {
    return {
        ticPrefix: patientData?.ticPrefix,
        ticNumber: patientData?.ticNumber,
        gender: patientData?.gender,
        isChild: patientData?.isChild,
        diagnose: patientData?.diagnose,
        ventilated: patientData?.ventilated,
        unitType: patientData?.unitType,
        unitTypeSpec: patientData?.unitTypeSpec,
        callSign: patientData?.callSign,
        transportPriority: patientData?.transportPriority,
        hospitalType: patientData?.hospitalType,
    };
}